import { Component } from '@angular/core';

@Component({
  selector: 'app-activity-controls',
  templateUrl: './activity-controls.component.html',
  styleUrls: ['./activity-controls.component.css']
})
export class ActivityControlsComponent {
screenSetting:any;
CTSetting:any;

constructor(){
this.screenSetting='default';

}
screenSettings(event:any){
  this.screenSetting=event
}

backClick(){
  this.screenSetting='activity';
}
backToMenu(){
  this.screenSetting='default';

}
}
